import { Color, EllipsoidSurfaceAppearance, GeometryInstance, Material, Primitive, Math as CesiumMath, GroundPrimitive, ClassificationType, PolygonGeometry, PolygonHierarchy, Cartographic, } from "cesium";
import { AssetType } from "../../types";
const createImagePrimitive = ({ file, assetId, wgs84CornerPositions: cornerPositions, isVisible, disableDepthTest, }) => {
    // get terrain height
    let imageUrl = "";
    try {
        imageUrl = URL.createObjectURL(file);
    }
    catch (e) {
        imageUrl = "";
    }
    // const imageUrl = URL.createObjectURL(file);
    const cornerVertices = cornerPositions;
    const bearing = calculateBearing(cornerVertices[2], cornerVertices[0]);
    // describe image above the terrain
    const primitive = new Primitive({
        geometryInstances: new GeometryInstance({
            geometry: new PolygonGeometry({
                polygonHierarchy: new PolygonHierarchy([
                    cornerVertices[0],
                    cornerVertices[1],
                    cornerVertices[3],
                    cornerVertices[2],
                ]),
                stRotation: CesiumMath.toRadians(bearing),
                perPositionHeight: true, // when false, the below height is applied to each vertex
                // height: DEFAULT_OFFSET_FROM_TERRAIN + centerHeight,
                vertexFormat: EllipsoidSurfaceAppearance.VERTEX_FORMAT,
                granularity: CesiumMath.DEGREES_PER_RADIAN,
            }),
            id: {
                id: assetId,
                type: "image",
                allowPicking: true,
                pickInfo: { assetType: AssetType.REFERENCE_TOPOLOGY },
            },
        }),
        appearance: new EllipsoidSurfaceAppearance({
            aboveGround: false,
            renderState: {
                depthTest: {
                    enabled: !disableDepthTest,
                },
            },
            material: new Material({
                fabric: {
                    type: "Image",
                    uniforms: {
                        image: imageUrl,
                        color: new Color(1.0, 1.0, 1.0, 0.5),
                    },
                },
                translucent: true,
            }),
        }),
        asynchronous: false,
    });
    primitive.show = isVisible;
    return primitive;
};
function calculateBearing(startPoint, endPoint) {
    var start = Cartographic.fromCartesian(startPoint);
    var end = Cartographic.fromCartesian(endPoint);
    var y = Math.sin(end.longitude - start.longitude) * Math.cos(end.latitude);
    var x = Math.cos(start.latitude) * Math.sin(end.latitude) -
        Math.sin(start.latitude) *
            Math.cos(end.latitude) *
            Math.cos(end.longitude - start.longitude);
    var bearing = Math.atan2(y, x);
    return CesiumMath.toDegrees(bearing);
}
const createImageGroundPrimitive = ({ file, assetId, wgs84CornerPositions: cornerPositions, isVisible, }) => {
    let imageUrl = "";
    try {
        imageUrl = URL.createObjectURL(file);
    }
    catch (e) {
        imageUrl = "";
    }
    const cornerVertices = cornerPositions;
    const bearing = calculateBearing(cornerVertices[2], cornerVertices[0]);
    // describe image above the terrain
    const primitive = new GroundPrimitive({
        geometryInstances: new GeometryInstance({
            geometry: new PolygonGeometry({
                polygonHierarchy: new PolygonHierarchy([
                    cornerVertices[0],
                    cornerVertices[1],
                    cornerVertices[3],
                    cornerVertices[2],
                ]),
                stRotation: CesiumMath.toRadians(bearing),
                perPositionHeight: true,
                vertexFormat: EllipsoidSurfaceAppearance.VERTEX_FORMAT,
            }),
            id: {
                id: assetId,
                type: "image",
                allowPicking: true,
                pickInfo: { assetType: AssetType.REFERENCE_TOPOLOGY },
            },
        }),
        appearance: new EllipsoidSurfaceAppearance({
            material: new Material({
                fabric: {
                    type: "Image",
                    uniforms: {
                        image: imageUrl,
                        color: new Color(1.0, 1.0, 1.0, 0.5),
                    },
                },
                translucent: true,
            }),
        }),
        asynchronous: false,
        classificationType: ClassificationType.BOTH,
    });
    primitive.show = isVisible;
    return primitive;
};
export function createDrawing2DImagePrimitive(args) {
    return args.isDraped
        ? createImageGroundPrimitive(args)
        : createImagePrimitive(args);
}
//# sourceMappingURL=utils.js.map